/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgPlatformApps = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.55 1.5h-7.1A2.952 2.952 0 001.5 4.45v7.1a2.952 2.952 0 002.95 2.95h7.1a2.953 2.953 0 002.95-2.95v-7.1a2.953 2.953 0 00-2.95-2.95zm1.95 10.05a1.952 1.952 0 01-1.95 1.95h-7.1a1.953 1.953 0 01-1.95-1.95v-7.1A1.953 1.953 0 014.45 2.5h7.1a1.952 1.952 0 011.95 1.95v7.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 4.478h-.5L5.075 6.022l-.25.432v3.09l.25.432 2.675 1.546h.5l2.675-1.546.25-.432v-3.09l-.25-.433L8.25 4.478zm1.925 4.772L8 10.5 5.825 9.25v-2.5L8 5.5l2.175 1.25v2.5z"
}));

export default SvgPlatformApps;